import Script from 'next/script';
import { useState } from 'react';
import * as Popover from '@radix-ui/react-popover';
import Image from 'next/image';
import clsx from 'clsx';
import ChatbotSvg from '@images/chatbot.svg';

function Chatbot() {
  const [allowDsgvo, setAllowDsgvo] = useState(false);
  const [open, setOpen] = useState(false);

  return (
    <>
      {!allowDsgvo ? (
        <Popover.Root open={open}>
          <Popover.Trigger asChild>
            <button
              className="gdpr-popover__trigger"
              aria-label="Popover Chatbot öffnen"
              onClick={() => {
                // @ts-ignore
                _paq.push([
                  'trackEvent',
                  'Opened Chatbot',
                  'Click Open Chatbot',
                  'Opened Chatbot Cookiebanner',
                ]);

                setOpen(!open);
              }}
            >
              <ChatbotSvg className="gdpr-popover__svg" />
            </button>
          </Popover.Trigger>
          <Popover.Portal>
            <Popover.Content
              className={clsx('PopoverContent')}
              sideOffset={5}
              onInteractOutside={() => setOpen(false)}
            >
              <div className="gdpr-popover">
                Nutze unseren digitalen, mehrsprachigen 24/7 Service. Für eine
                reibungslose Nutzung erfolgt die Weitergabe deiner Daten an
                Drittanbieter (s.{' '}
                <a href="/datenschutz" target="_blank" rel="noreferrer">
                  Datenschutz
                </a>
                )
                <div className="gdpr-popover__buttons">
                  <button
                    className="button"
                    onClick={() => {
                      // @ts-ignore
                      _paq.push([
                        'trackEvent',
                        'Decline Cookies',
                        'Click Decline Button',
                        'Declined Chatbot Cookies',
                      ]);
                      setOpen(false);
                    }}
                    id="decline-cookies-button"
                  >
                    Ablehnen
                  </button>
                  <button
                    className="button button--primary"
                    onClick={() => {
                      // @ts-ignore
                      _paq.push([
                        'trackEvent',
                        'Allow Cookies',
                        'Click Allow Button',
                        'Allowed Chatbot Cookies',
                      ]);
                      setOpen(false);
                      setAllowDsgvo(true);
                    }}
                    id="accept-cookies-button"
                  >
                    Erlauben
                  </button>
                </div>
              </div>
              <Popover.Arrow className="PopoverArrow" />
            </Popover.Content>
          </Popover.Portal>
        </Popover.Root>
      ) : null}
      {allowDsgvo ? (
        <Script
          async
          defer
          strategy="lazyOnload"
          src={`https://stable.loyjoy.com/widget.js?process=${
            process.env.NEXT_PUBLIC_CHATBOT_CODE
          }${
            process.env.NEXT_PUBLIC_BASE_URL !==
            'https://schwalbe.stadtwerke-witten.de'
              ? '&loyjoy-open=true'
              : ''
          }`}
        />
      ) : null}
    </>
  );
}

export default Chatbot;
